import React from 'react';
import { compose } from 'redux';
import withRouteParams from 'hoc/withRouteParams';
import { connect } from 'react-redux';
import { useParams, Redirect } from 'react-router-dom';
import { getPersonalInfo, getBalanceToSettle } from 'ducks/customerDetails';
import { updateAppLoading } from 'ducks/meta';
import { getSuspensionInfo, getSuspension } from 'ducks/suspensions';
import withScrollableTopTabs from 'hoc/withScrollableTopTabs';
import customerPageTopTabs from 'constants/customerPageTopTabs';
import permissionTypes from 'constants/permissionTypes';
import { AddSuspensionPage, EditSuspensionPage } from './Suspension';

const mapStateToProps = (state, ownProps) => {
  const canSuspendIgnoreSuspensionRules = state.auth.permissions.includes(
    permissionTypes.canSuspendIgnoreSuspensionRules
  );
  const canManageSuspensions = state.auth.permissions.includes(
    permissionTypes.canManageSuspensions
  );
  return {
    customerDetails:
      state.customerDetails.adfitNo === ownProps.routeParams.adfitNo
        ? state.customerDetails
        : {},
    suspensionInfo: state.suspensions.suspensionInfo,
    hasSuspensionRuleForAccount: state.suspensions.hasSuspensionRuleForAccount,
    canChargeForSuspension: state.suspensions.canChargeForSuspension,
    suspensionRuleLoading: state.suspensions.suspensionRuleLoading,
    currentSuspension: state.suspensions.currentSuspension,
    localisation: state.localisation,
    canSuspendIgnoreSuspensionRules,
    canManageSuspensions,
  };
};

const mapDispatchToProps = {
  getPersonalInfo,
  getBalanceToSettle,
  getSuspensionInfo,
  getSuspension,
  updateAppLoading,
};

export const AddSuspension = compose(
  withScrollableTopTabs(customerPageTopTabs, 1, ['adfitNo']),
  withRouteParams,
  connect(mapStateToProps, mapDispatchToProps)
)(AddSuspensionPage);

export const EditSuspension = compose(
  withScrollableTopTabs(customerPageTopTabs, 1, ['adfitNo']),
  withRouteParams,
  connect(mapStateToProps, mapDispatchToProps)
)(EditSuspensionPage);

export const RedirectToSuspensionsPage = () => {
  const { adfitNo } = useParams();
  return <Redirect to={`/Customers/${adfitNo}/Payments/Suspensions`} />;
};
